import './SegmentationsGroup.scss';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { ReactElement, useState } from 'react';
import { ObjectListActions } from './ObjectListActions';
import { IObjectListSegmentation } from './ObjectsList.container';
import { SegmentationWithActions } from './SegmentationWithActions';

interface IMarkingToolGroupItemProps {
  isReadOnly: boolean;
  segmentations: IObjectListSegmentation[];
  onAnnotationTypeHiddenClick: (annotationTypeId: string) => void;
  onSegmentationHiddenClick: (segmentation: IObjectListSegmentation) => void;
  onDeleteAnnotationTypeClick: (annotationTypeId: string) => void;
  onDeleteSegmentationClick: (segmentation: IObjectListSegmentation) => void;
  onSegmentationClick: (segmentation: IObjectListSegmentation) => Promise<void>;
}

export const SegmentationsGroup = ({
  isReadOnly,
  segmentations,
  onAnnotationTypeHiddenClick: onAnnotationTypeHiddenClicked,
  onSegmentationHiddenClick: onSegmentationHiddenClicked,
  onDeleteAnnotationTypeClick: onDeleteAnnotationTypeClicked,
  onDeleteSegmentationClick: onDeleteSegmentationClicked,
  onSegmentationClick: onSegmentationClicked,
}: IMarkingToolGroupItemProps): ReactElement => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  const toggle = (): void => {
    setIsOpened(!isOpened);
  };
  const handleAnnotationTypeShowHideClicked = (): void => {
    onAnnotationTypeHiddenClicked(segmentations[0].feature.properties?.annotationTypeId);
  };
  const handleAnnotationTypeDeleteClicked = (): void => {
    onDeleteAnnotationTypeClicked(segmentations[0].feature.properties?.annotationTypeId);
  };
  const getSegmentationShowHideClicked = (segmentation: IObjectListSegmentation) => (): void => {
    onSegmentationHiddenClicked(segmentation);
  };
  const getHandleDeleteSegmentationClicked = (segmentation: IObjectListSegmentation) => (): void => {
    onDeleteSegmentationClicked(segmentation);
  };
  const getHandleSegmentationClicked = (segmentation: IObjectListSegmentation) => async (): Promise<void> => {
    await onSegmentationClicked(segmentation);
  };

  const isVisible = segmentations[0].isMarkingToolTypeVisible;

  return (
    <div className='segmentations-group'>
      <div className='segmentations-group-header'>
        <div className='segmentations-group-header-left-container'>
          <div className={`segmentations-group-label ${segmentations.some((s) => s.isSelected) ? 'selected' : ''}`}>
            <SegmentationWithActions
              isReadOnly={isReadOnly}
              objectListSegmentation={segmentations[0]}
              showActions={false}
            />
            <div className='segmentations-amount-label'>&nbsp; ({segmentations.length})</div>
          </div>
          <div
            className='segmentations-group-chevron-container'
            onClick={toggle}
          >
            {isOpened && (
              <FontAwesomeIcon
                className='segmentations-group-header-chevron'
                icon={faChevronUp}
              />
            )}
            {!isOpened && (
              <FontAwesomeIcon
                className='segmentations-group-header-chevron'
                icon={faChevronDown}
              />
            )}
          </div>
        </div>
        <ObjectListActions
          isDeleteVisible={!isReadOnly}
          isVisible={isVisible}
          onDeleteClick={handleAnnotationTypeDeleteClicked}
          onShowHideClick={handleAnnotationTypeShowHideClicked}
        />
      </div>
      {isOpened && (
        <div className='segmentations-group-items'>
          {_.map(segmentations, (s, index) => (
            <SegmentationWithActions
              key={s.feature.id}
              isReadOnly={isReadOnly}
              objectListSegmentation={s}
              index={index + 1}
              onShowHideClick={getSegmentationShowHideClicked(s)}
              onDeleteClick={getHandleDeleteSegmentationClicked(s)}
              onClick={getHandleSegmentationClicked(s)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
